module.exports = __webpack_public_path__ + "static/media/snow_light.dbd18779.svg";